<template>
    <div class="elder-buzhu">
        <mt-header fixed title="助补信息编辑">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mt-radio title="政府补助" v-model="allowance_gov" :options="allowanceGovOptions"></mt-radio>
            <mt-checklist title="政府补助标准" v-model="allowance_gov_standard" :options="allowanceGovStandardOptions"></mt-checklist>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    import mintSelect from '../../components/mintSelect.vue'

    export default{
        components: {
            'mint-select':mintSelect
        },

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,

                allowance_gov:'',
                allowanceGovOptions: [],

                allowance_gov_standard:[],
                allowanceGovStandardOptions:[]

            }
        },

        methods:{
            //mini-select
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateElder(){

                this.$indicator.open('加载中');

                this.$axios.post("/elder/buzhu", {openid:this.openid,elder:this.id,allowance_gov:this.allowance_gov,allowance_gov_standard:this.allowance_gov_standard})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('修改成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            }
        },

        created(){
            this.$axios.get('/elder/buzhu?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        let elder_info = data.data.data;

                        var allowance_gov_array = Array();
                        for(let i=0;i<data.data.options.allowance_gov.length;i++){
                            allowance_gov_array[i] = { label:data.data.options.allowance_gov[i],value:data.data.options.allowance_gov[i]};
                        }
                        this.allowanceGovOptions = allowance_gov_array;
                        this.allowance_gov = elder_info.allowance_gov;

                        var allowance_gov_standard_array = Array();
                        for(let i=0;i<data.data.options.allowance_gov_standard.length;i++){
                            allowance_gov_standard_array[i] = { label:data.data.options.allowance_gov_standard[i],value:data.data.options.allowance_gov_standard[i]};
                        }
                        this.allowanceGovStandardOptions = allowance_gov_standard_array;
                        this.allowance_gov_standard = elder_info.allowance_gov_standard===null?[]:elder_info.allowance_gov_standard.split(',');
                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }



    }
</script>


// WEBPACK FOOTER //
// src/pages/elder/buzhu.vue